import React,{useState, useEffect, useRef} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { COOKIESPREFIX } from '../config.js';
import Nav from '../components/Nav'
//
import {postReqestOTP, postLoginOTP} from '../services/service.js'
import { useTimer } from '../hooks/useTimer.jsx';
import '../App.css'
import { useLayoutEffect } from 'react';
//screens
function App({gameState}) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
  const [popType, setPopType] = useState(null)
  const [phoneNum, setPhoneNum] = useState(gameState?.phone || '')
  const [haveNumCookie, setHaveNumCookie] = useState(false)
  const [verifyOTP, setVerifyOTP] = useState(null)
  const [countdown, setCountDown] = useTimer()
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [errMsg, setErrMsg] = useState(null)
  const [phoneBgLoaded, setPhoneBgLoaded] = useState(false)
  const [otpBgLoaded, setOtpBgLoaded] = useState(false)

  const inputRef = useRef()
  const phoneRef = useRef()
  const optRef0 = useRef(null)
  const optRef1 = useRef(null)
  const optRef2 = useRef(null)
  const optRef3 = useRef(null)
  //
  const tncRef = useRef()
  const personalRef = useRef()
  const [isChecked, setIsChecked] = useState({})
  useEffect(() => {
    if(cookies[`@${COOKIESPREFIX}_token`]) return navigate('/gamemap')
  },[])
  async function submitNumber(){
    if(!/^\d+$/.test(phoneNum) || phoneNum.length !== 8)return setErrMsg('請輸入正確的香港流動電話號碼。');
    if(!isChecked.TC) return setErrMsg('請確認所有方框。');
    const res = await postReqestOTP(phoneNum)
    if(res.errno) return setErrMsg('您的流動電話號碼已被登記並成功兌換禮品。多謝參與！');
    setHaveNumCookie(true)
    setCountDown(60)
  }
  async function submitVerifyCode(){
    if(verifyOTP.length !== 4) return;
    const res = await postLoginOTP(phoneNum, verifyOTP)
    if(res.errno) return;
    setCookie(`@${COOKIESPREFIX}_token`, res.token.token, {maxAge:res.token.ttl})
    navigate('/rules')
  }
  function handlePhoneInput(e){
    if(e.target.value.length <= 8){
      setPhoneNum(e.target.value)
    }else{
      phoneRef.current.value = phoneNum
    }
  }
  function handleOTPInput(e){
    if(e.target.value.length <= 4){
      setVerifyOTP(e.target.value)
    }else{
      inputRef.current.value = verifyOTP
    }
  }
  async function resendOTP(){
    const res = await postReqestOTP(phoneNum)
    console.log(res)
    setCountDown(60)
  }
  function handleCheckboxToggle(key){
    setIsChecked(prev => {
      return{...prev, [key]: (!prev[key])}
    })
    console.log(isChecked)
  }
  function handleFTP(val, idx){
    console.log(val, idx)
    const refs = [optRef0, optRef1, optRef2, optRef3]
    if(!'0123456789'.includes(val)) return refs[idx].current.value = null;
    if(idx === 0){
      optRef0.current.value = val
      setVerifyOTP(val)
      optRef1.current.focus()
      optRef1.current.value = null
    }else if(idx === 1){
      optRef1.current.value = val
      setVerifyOTP(og => og.slice(0,1) + val)
      optRef2.current.focus()
      optRef2.current.value = null
    }else if(idx === 2){
      optRef2.current.value = val
      setVerifyOTP(og => og.slice(0,2) + val)
      optRef3.current.focus()
      optRef3.current.value = null
    }else if(idx ===3){
      optRef3.current.value = val
      setVerifyOTP(og => og.slice(0,3) + val)
    }
  }

  const topRef= useRef(null)
  useLayoutEffect(()=>{
      setTimeout(()=>{
        if(topRef?.current)
         topRef.current.scrollIntoView();
      },500)
  },[])

  
  useEffect(() => {
    console.log(verifyOTP,popType)
  },[verifyOTP,popType])

  return (
    <div className="flex flex-col items-center w-[100%] h-[100%] overflow-y-auto">
      <div ref={topRef}/>
      <div className='relative w-full'>
        {/* <div style={{zIndex:1}} className='h-full flex flex-row items-center justify-center'>
          <video loop src='/loop.mp4' muted controls={false} autoPlay={true} playsInline/>        
        </div> */}
        {popType === null && <div onClick={() => setIsNavOpen(true)} className='w-[9%] h-[3%] top-[10%] left-[84%] absolute flex flex-col items-center justify-between' style={{zIndex:98}}>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
        </div>}
        <Nav closeNav={() => setIsNavOpen(false)} isNavOpen={isNavOpen} />
        <div style={{ position: 'relative', top:0, left:0 }}>
            {/* <video style={{ position: 'absolute', top: 0, left: 0, zIndex: 0 }} loop muted controls={false} autoPlay playsInline src='/bgloopv2.mp4' /> */}
            {!haveNumCookie && <img src='/images/signupbg.png' onLoad={() => setPhoneBgLoaded(true)} className='w-full' style={{ position: 'relative', zIndex: 10, top:0 }} alt="Background Image" />}
            {haveNumCookie &&<img src={'/images/otpbg.png'} onLoad={() => setOtpBgLoaded(true)} className='w-full' style={{ position: 'relative', zIndex: 10, top:0 }} alt="Background Image" />}
        </div>
        {/* phone signup */}
        {(!haveNumCookie && phoneBgLoaded) && <div style={{zIndex:97}} className='absolute top-0 left-0 w-[100%] h-full'>
          {popType !== null && <div className='absolute w-[100%] h-[100%] bg-white' style={{backdropFilter: 'blur(10px)', zIndex:99}}>
            <div className='h-[100vh] w-[100%] flex flex-col items-center justify-center'>
              <div className='absolute top-[0%] left-[0] select-none flex justify-end w-full bg-white'>
                <img src='/images/tctop.png' className='w-[100%]'></img>
              </div>
              <div className='max-h-[100vh] w-[100%] flex flex-col px-[4%] py-[15%] relative'>
                <div className='absolute right-[5%] top-[3%] select-none flex justify-end' onClick={() => setPopType(null)}>
                  <img src='/images/btn/closetnc.png' className='w-[50%]'></img>
                </div>
                {popType === 'TC' && 
                <div id={'tnc-scroll'} className='h-full w-full flex flex-col overflow-y-scroll text-[12px] mt-[30%] text-justify'>
                  <div className='font-bold text-[18px] mb-[14px] w-full bg-[#f0f0f0]'>「崇光啟德店探索之旅」遊戲之條款及細則</div>
                  <div className='font-bold mb-[14px] underline'>「崇光啟德店探索之旅」 之一般條款及細則：</div>
                  <div className=''>「崇光啟德店探索之旅」(下稱「<b>本推廣</b>」) 打卡遊戲(下稱「打卡遊戲」)屬於中銀信用卡(國際)有限公司(下稱「<b>卡公司</b>」)之推廣活動。「打卡遊戲」由Zephyr Design Studio Limited (「本公司」)營運及管理，而獎賞派發會由卡公司提供。</div>
                  <div style={{whiteSpace:'pre-wrap'}}>{}</div>
                  <div className='mt-[12px]'>推廣期：</div>
                  <div>本推廣由即日至2025年2月28日結束(下稱「<b>推廣期</b>」)，日期及時間紀錄以本公司之伺服器接收為準。</div>
                  <div className='underline mt-[12px] font-bold'>成為「合資格參加者條件」：</div>
                  <div>於推廣期內，參加者須開立遊戲賬戶，透過完成遊戲並符合指定條件，便有機會獲得由卡公司送出的獎賞。</div>
                  <ol>
                  <div className='flex flex-row'>
                    <div className='font-bold'>1.</div>
                    <div className=''>有關開立遊戲賬戶的條件：</div>
                  </div>
                  <div className='flex flex-row ml-[14px]'>
                    <div className='font-bold'>i.</div>
                    <div className=''>參加者需要輸入一個可接收短訊驗證碼之香港流動電話號碼，以建立賬戶之用戶(「<b>合資格參加者</b>」)。</div>
                  </div>
                  <div className='flex flex-row'>
                    <div className='font-bold'>2.</div>
                    <div className=''>每位合資格參加者只可參與活動遊戲一次。</div>
                  </div>
                  <div className='flex flex-row'>
                    <div className='font-bold'>3.</div>
                    <div className=''>若合資格參加者的參加資格存疑，卡公司及本公司將有最終決定權，及將不承擔任何損失，也不會就參加資格及相關獎賞以任何形式補發。</div>
                  </div>
                  </ol>
                  <div className='underline mt-[12px] '>遊戲玩法：</div>
                  <ul>
                  <div className='flex flex-row'>
                    <div className='font-bold '>1.</div>
                    <div className=''>合資格參加者將透過揀選不同的購物達人角色去挑戰關卡以完成任務(「任務」)，當成功挑戰，即「任務」完成可自動獲得相應達人角色的獎賞(「合資格獎賞」)。當合資格參加者完成任務後將獲得獎賞二維碼，並可憑此二維碼到獎賞中銀崇光活動專櫃(G-10店，Longchamp旁)兌換獎賞。</div>
                  </div>
                  <div className='flex flex-row'>
                    <div className='font-bold '>2.</div>
                    <div className=''>合資格參加者完成任務後可選擇領取其達人角色之扭蛋機遊戲機會一次，以獲得其所揀選購物達人角色之「合資格獎賞」一份，唯所有達人角色之「合資格獎賞」的價值為相同的獎賞。中銀崇光活動專櫃的工作人員將會為合資格參加者送上相應的獎賞。
                  </div>
                  </div>
                  <div className='flex flex-row'>
                    <div className='font-bold '>3.</div>
                    <div className=''>每日派出的「合資格獎賞」均設有固定名額，並根據合資格參加者達到完成任務的時間及到達獎賞換領點去兌換獎賞的時間為準，以先到先得的形式給予獎賞予用戶。</div>
                  </div>
                  <div className='flex flex-row'>
                    <div className='font-bold '>4.</div>
                    <div className=''>「合資格獎賞」的名額有限，先到先得，送完即止，卡公司及本公司將不承擔任何損失，也不會將獎賞補發給合資格參加者。</div>
                  </div>
                  </ul>
                  <div className='underline mt-[12px] font-bold'>免責聲明：</div>
                  {['本公司會盡力將儲存在「打卡遊戲」遊戲系統內的個人資料保密，免受到不必要的盜取及使用，但鑑於互聯網的性質，本公司不能對資料傳送安全和保密作出完全保證或聲明。若閣下發現資料在未經授權下遭洩漏，請立即與本公司聯絡。',
                    '與「打卡遊戲」連結的其他網站，也可能蒐集你個人的資料，本公司 「打卡遊戲」的私隱條款將不適用於瀏覽者從「打卡遊戲」連結到其他網站及繼續閱讀其他網站時被收集個人資料，你須自行承擔有關風險，本公司對於連結其他網站上所載資訊的準確性、有效性、安全性或如有任何遺漏，均不承擔任何責任。',
                    '如有任何因網絡、電話、技術或不可歸責於 本公司及卡公司的事由，而使參加者所寄出的、登錄的資料或使本公司及卡公司寄出的通知，有遲延、遺失、錯誤、無法辬識或損毀的情況， 本公司及卡公司不會負任何法律責任。',
                    '參加者如因參加「打卡遊戲」或因遊戲獎項而遭任何損失，本公司及卡公司不會負任何責任。一旦得獎者領取獎品後，若有遺失或被竊，本公司及卡公司亦不會發給任何證明或補償。',
                  ].map((word,i) => 
                  <div className='flex flex-row' key={word}>
                    <div className='font-bold'>{i+1}.</div>
                    <div className=''>{word}</div>
                  </div>)}
                  <div className='underline mt-[12px] font-bold'>一般條款及細則：</div>
                  {['上述產品、服務與優惠受有關條款約束，詳情請參閱相關宣傳品、向有關商戶或中銀香港及/或卡公司職員查詢。',
                    '所有資料及圖片只供參考。',
                    '網頁及/或應用程式的使用條款須受供應商的相關條款所約束。中銀香港及/或卡公司並非流動支付工具應用程式的供應商。客戶如對商戶之網頁及/或流動支付工具應用程式有任何查詢或投訴，請直接與商戶及/或有關供應商聯絡。中銀香港及/或卡公司並不會對商戶之網頁及/或供應商提供的手機應用程式或其服務作出任何保證，或對於使用其手機應用程式或服務時所構成的後果負責。',
                    '中銀香港及/或卡公司並無審閱或核實商戶之網頁及/或第三方流動應用程式內的資訊或其刊載或提供的資料、産品或服務或私隱慣例的責任，且一概不就使用上述各項所産生的任何損失承擔責任（不論疏忽或其他方式）。中銀香港及/或卡公司並非認同或推薦該網頁及/或流動應用程式所刊載或提供的任何資訊、資料、産品或服務，亦一概不就該等流動應用程式所刊載或提供的資訊、資料、産品或服務的任何的不確或失當負責。請審閱有關第三方流動應用程式載有的條款及條件、相關免責聲明及私隱政策。',
                    '客戶需自行支付瀏覽網頁及/或第三方流動應用程式所產生的相關數據費用。',
                    '除有關客戶、中銀香港及/或卡公司以外，並無其他人士有權按《合約(第三者權利)條例》強制執行本條款及細則的任何條文或享有本條款及細則任何條文下的利益。',
                    '中銀香港及/或卡公司並非商戶的供應商。客戶如對商戶提供的貨品或其服務有任何查詢或投訴，請直接與有關商戶聯絡。中銀香港及/或卡公司對商戶及/或其供應商提供的貨品或服務質素(包括但不限於產品質素及供應量)一概不承擔任何責任，不會作出任何保證，亦不會對於使用其貨品或服務時所構成的後果負責。商戶將負上所有產品及服務的法律責任。',
                    '中銀香港及/或卡公司及/或商戶保留更改、暫停或取消本推廣或修訂本條款及細則之酌情權。',
                    '如有任何爭議，中銀香港及/或卡公司及/或商戶對所有事宜及爭議保留最終決定權。',
                    '如此條款及細則的中、英文版有所差異，一概以中文版為準。',
                  ].map((word,i) => 
                  <div className='flex flex-row' key={word}>
                    <div className='font-bold'>{i+1}.</div>
                    <div className=''>{word}</div>
                  </div>)}
                  <div className='mt-[12px]'>提示：借定唔借？還得到先好借！</div>
                  <div className='font-bold text-[18px] mt-[14px] w-full bg-[#f0f0f0]'>個人收集資料聲明</div>
                  <div className='underline mt-[12px] font-bold'>個人資料用途：</div>
                  <div className='flex flex-row' key={'「打卡遊戲」由 Zephyr Desi'}>
                  <div className='font-bold'>{1}.</div>
                  <div>
                    「打卡遊戲」由 Zephyr Design Studio Limited (「本公司」)營運及管理，而獎賞派發安排會由中銀信用卡(國際)有限公司(下稱「<b>卡公司</b>」)管理。
                  </div>
                  </div>
                  {[
                  '本公司所收集的個人資料(定義見「個人資料」於個人資料(私隠)條例之定義)，包括玩家於登記時透過填寫登記表格向本公司提供的電話及/或電郵地址。如果客戶有需要更改個人資料，可於遊戲內提交申請，透過手機短訊一次性密碼驗證後可到本公司指定網頁更改個人資料。',
                  '參加者於本活動提供予本公司之個人資料只會分享予卡公司於活動爭議時作為獎品後補派發聯絡之用及保留紀錄之用途。如你不同意將你的個人資料交予本公司，你便未能成功開立遊戲賬戶，你應當自行評估相關風險。',
                  '參加者於本活動提供予本公司之個人資料將會在活動完結後2個月後銷毀。',
                  '卡公司及本公司不會對上述安排之安全性作出任何保證及對你因以上安排所產生的任何損失作出䏽償及承擔任何責任。如對活動有任何查詢或更改資料，可以聯絡卡公司或本公司查詢。',
                  ].map((word,i) => 
                  <div className='flex flex-row' key={word}>
                    <div className='font-bold'>{i+2}.</div>
                    <div className=''>{word}</div>
                  </div>)}
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                </div>}
                {popType === 'TC' &&<div className='w-full mb-[24px] flex justify-center items-ceter'>
                  <img src='/images/btn/back.png' className='cursor-pointer max-w-[50%]' onClick={() => {setPopType(null);}}/>
                </div>}
                {popType === 'PY' && <div className='h-full w-full flex flex-col'>
                  Privacy
                </div>}
                {popType === 'PI' && <div className='h-full w-full flex flex-col'>
                  Personal Informaiton
                </div>}
              </div>
            </div>
          </div>}
          <div style={{top:'47.5%', left:'0%'}} className='h-[7%] w-full px-[20%] absolute flex flex-row items-center justify-center text-[#FF800D] font-bold text-[22px]'>
            {'+852 '}
            {/* {phoneNum} */}
            <input inputMode="numeric" ref={phoneRef} onChange={(e) => handlePhoneInput(e)} value={phoneNum} className='ml-[12px] bg-transparent outline-none w-full text-center'></input>
          </div>
          {/* <input type='tel' required={true} ref={phoneRef} max={8} pattern="[0-9]{8}" placeholder='phone no.' onChange={(e) => handlePhoneInput(e)} className='text-white bg-transparent outline-none border h-[0px] absolute top-[-1%]'></input> */}
          {errMsg && <div style={{zIndex:5}} className='w-[8%] h-[3.2%] absolute top-[54.3%] left-[0%] flex flex-row items-center w-full px-[38px]'>
            <div className='ml-[12px] text-[14px] font-[500] text-[#FF0000]'>{errMsg}</div>
          </div>}
          <div style={{zIndex:5}} className='w-[8%] h-[3.2%] absolute top-[60%] left-[0%] flex flex-row items-center w-full px-[38px]'>
            {isChecked.TC ? <img src='/images/btn/ticked.png' className='w-[10%]' style={{height:undefined, aspectRatio:63/67}}></img> : <img onClick={() => {handleCheckboxToggle('TC')}} src='/images/btn/notick.png' className='w-[10%]' style={{height:undefined, aspectRatio:63/67}}></img>}
            <div className='ml-[12px] text-[14px] text-[#15365d]'>本人同意已閱讀並同意<span className='font-[500] underline' onClick={() => setPopType('TC')}>此「崇光啟德店探索之旅」遊戲之條款及細則及個人資料收集聲明。</span></div>
          </div>
          {/* <div style={{zIndex:5}} className='w-[8%] h-[3.2%] absolute top-[62.6%] left-[0%] flex flex-row items-center w-full px-[38px]'>
            {isChecked.PI ? <img src='/images/btn/ticked.png' className='w-[10%]' style={{height:undefined, aspectRatio:63/67}}></img> : <img onClick={() => handleCheckboxToggle('PI')} src='/images/btn/notick.png' className='w-[10%]' style={{height:undefined, aspectRatio:63/67}}></img>}
            <div className='ml-[12px] text-[14px] text-[#15365d]'>本人<span className='font-[500] underline' onClick={() => setPopType('TC')}> 同意按照此個人收集資料聲明及私隱政策</span>所述使用本人的個人資料作活動登記及獎品領取之用。</div>
          </div> */}
          <div type='submit' value={''} className='absolute top-[66%] left-[0%] w-full flex flex-col items-center justify-center'>
            <div className='text-[#FF0000] text-[14px] max-w-[70vw] text-center'>每一個香港流動電話號碼只可登記此活動及領取相關獎賞一次。</div>
            {(isChecked.TC) ? <img onClick={() => {submitNumber()}} src='/images/btn/confirm.png' className='w-[50%]' style={{height:undefined, aspectRatio:370/156}} /> : <img src='/images/btn/greyconfirm.png' onClick={submitNumber} className='w-[50%]' style={{height:undefined, aspectRatio:370/156}}/>}
          </div>
        </div>}
        
        {/* OTP */}
        {(haveNumCookie && otpBgLoaded) && <>
          <div style={{zIndex:97}} className='absolute w-full h-full top-0 left-0'>
            {/* <div>{phoneNum}</div> */}
            {/* <input max={4} pattern="[0-9]{4}" type='number' inputmode="numeric" ref={inputRef} className='bg-transparent w-[0px]' onChange={(e) => {handleOTPInput(e)}}></input> */}
            <div className='w-full h-[7%] absolute top-[54%] flex items-center justify-center gap-[7%]'>
              <input type='number' inputmode="numeric" ref={optRef0} onClick={() => {optRef0.current.value = null;setVerifyOTP(og => og?.slice(0,0))}} value={verifyOTP?.[0]} onChange={(e) => {handleFTP(e.target.value, 0)}} className='text-[#dd7819] outline-none h-[70%] w-[10%] flex items-center justify-center text-[26px] font-bold bg-transparent text-center'></input>
              <input type='number' inputmode="numeric" ref={optRef1} onClick={() => {optRef1.current.value = null;setVerifyOTP(og => og?.slice(0,1))}} value={verifyOTP?.[1]} onChange={(e) => {handleFTP(e.target.value, 1)}} className='text-[#dd7819] outline-none h-[70%] w-[10%] flex items-center justify-center text-[26px] font-bold bg-transparent text-center'></input>
              <input type='number' inputmode="numeric" ref={optRef2} onClick={() => {optRef2.current.value = null;setVerifyOTP(og => og?.slice(0,2))}} value={verifyOTP?.[2]} onChange={(e) => {handleFTP(e.target.value, 2)}} className='text-[#dd7819] outline-none h-[70%] w-[10%] flex items-center justify-center text-[26px] font-bold bg-transparent text-center'></input>
              <input type='number' inputmode="numeric" ref={optRef3} onClick={() => {optRef3.current.value = null;setVerifyOTP(og => og?.slice(0,3))}} value={verifyOTP?.[3]} onChange={(e) => {handleFTP(e.target.value, 3)}} className='text-[#dd7819] outline-none h-[70%] w-[10%] flex items-center justify-center text-[26px] font-bold bg-transparent text-center'></input>
              {/* <div className='border border-black h-[70%] w-[10%] flex items-center justify-center text-[22px] font-bold'>{verifyOTP?.[0]}</div>
              <div className='border border-black h-[70%] w-[10%] flex items-center justify-center text-[22px] font-bold'>{verifyOTP?.[1]}</div>
              <div className='border border-black h-[70%] w-[10%] flex items-center justify-center text-[22px] font-bold'>{verifyOTP?.[2]}</div>
              <div className='border border-black h-[70%] w-[10%] flex items-center justify-center text-[22px] font-bold'>{verifyOTP?.[3]}</div> */}
            </div>
            {countdown < 1 && <div onClick={resendOTP} className='w-[20%] h-[3%] left-[40%] absolute top-[63%] text-[#dd7819] underline decoration-[#dd7819] text-center border'>重新發送</div>}
            {countdown !== 0 && <div className='h-[3%] left-[38%] absolute top-[63%] text-[#dd7819] underline decoration-[#dd7819]'>{`重新發送 (${countdown}s)`}</div>}
            {/* <div onClick={() => {inputRef.current.focus();setVerifyOTP(null);inputRef.current.value = ''}} className='w-full h-[7%] absolute top-[56.5%] border border-black'></div> */}
            {/* <div onClick={submitVerifyCode} className='w-[36%] h-[5%] absolute border border-black top-[70%] left-[32%]'>
            </div> */}
            <div type='submit' value={''} className='w-[36%] h-[5%] absolute top-[68%] left-[0%] w-full flex flex-row items-center justify-center'>
              {verifyOTP?.length === 4 ? <img onClick={() => {submitVerifyCode()}} src='/images/btn/confirm.png' className='w-[50%]' style={{height:undefined, aspectRatio:370/156}} /> : <img src='/images/btn/greyconfirm.png' className='w-[50%]' style={{height:undefined, aspectRatio:370/156}}/>}
            </div>
            <div className='w-[36%] h-[5%] absolute top-[75%] left-[0%] w-full flex flex-row items-center justify-center'>
              <img onClick={() => navigate('/')} src='/images/btn/back.png' className='w-[50%]' style={{height:undefined, aspectRatio:370/156}}/>
            </div>
          </div>
        </>}
      </div>
    </div>
  );
}

export default App;